import React from 'react';
import { Input, MultiselectField, Dropdown } from 'components';
import { SourceType } from 'graphql-query-contracts';
import { UnitInputFields, UnitInputFieldKey } from '../../types';
import styles from '../styles.scss';
import { SourceTypeLabel } from '../../../../../../../type-maps/source-type-label.map';
import { DropdownItem } from 'design-system-web';

const externalIdSourceOptions: DropdownItem<SourceType>[] = [
  {
    label: SourceTypeLabel[SourceType.SourceTypeActivate],
    value: SourceType.SourceTypeActivate,
    isDisabled: true,
  },
  {
    label: SourceTypeLabel[SourceType.SourceTypeCbre],
    value: SourceType.SourceTypeCbre,
  },
  {
    label: SourceTypeLabel[SourceType.SourceTypeMri],
    value: SourceType.SourceTypeMri,
  },
  {
    label: SourceTypeLabel[SourceType.SourceTypeSfdc],
    value: SourceType.SourceTypeSfdc,
  },
  {
    label: SourceTypeLabel[SourceType.SourceTypeVcm],
    value: SourceType.SourceTypeVcm,
  },
  {
    label: SourceTypeLabel[SourceType.SourceTypeYardi],
    value: SourceType.SourceTypeYardi,
  },
];

type UnitFormFieldsProps = {
  editUnit: UnitInputFields;
  enableExternalReference: boolean;
  options: any[];
  getErrorMessage: (field: UnitInputFieldKey) => string[];
  handleOnChange: (value: any, fieldName: string) => void;
  t: any;
  createPage: any;
  editPage: any;
};

export const UnitFormFields = ({
  editUnit,
  enableExternalReference,
  options,
  getErrorMessage,
  handleOnChange,
  t,
  createPage,
  editPage,
}: UnitFormFieldsProps) => (
  <div className={styles.leftCard}>
    <div>
      <Input
        fieldName="name"
        label={t(createPage.form.name.label)}
        fixedLabel
        testId="nameInput"
        value={editUnit.name}
        error={getErrorMessage('name')}
        onChange={value => handleOnChange(value, 'name')}
        placeholder={t(createPage.form.name.placeholder)}
        isRequired
      />
    </div>

    {enableExternalReference && (
      <div className={styles.externalReferenceContainer}>
        <Dropdown
          label={t(
            'web.admin.channel.units.create.form.externalIdSource.label'
          )}
          fixedLabel
          testId="externalIdSourceDropdown"
          placeholder={t(
            'web.admin.channel.units.create.form.externalIdSource.placeholder'
          )}
          noOptionsMessage={t(
            'web.admin.channel.units.create.form.externalIdSource.noSourceFound'
          )}
          items={externalIdSourceOptions}
          onChange={value => handleOnChange(value, 'externalIdSource')}
          value={editUnit.externalIdSource?.value}
          doTranslation={false}
          invalid={!!getErrorMessage('externalIdSource').length}
          errors={getErrorMessage('externalIdSource')}
          isClearable
        />
        <Input
          fieldName="externalUnitId"
          label={t(editPage.form.externalId.label)}
          fixedLabel
          testId="externalUnitIdInput"
          value={editUnit.externalUnitId}
          error={getErrorMessage('externalUnitId')}
          onChange={value => handleOnChange(value, 'externalUnitId')}
          placeholder={t(
            'web.admin.channel.units.create.form.externalUnitId.placeholder'
          )}
        />
      </div>
    )}

    <div>
      <Input
        fieldName="description"
        label={t('web.admin.channel.units.create.form.description.label')}
        fixedLabel
        testId="descriptionInput"
        value={editUnit.description}
        error={getErrorMessage('description')}
        onChange={value => handleOnChange(value, 'description')}
        placeholder={t(
          'web.admin.channel.units.create.form.description.placeholder'
        )}
      />
    </div>

    <div>
      <MultiselectField
        label={t('web.admin.channel.units.create.form.floors.label')}
        fixedLabel
        isFullWidth
        testId="floorsDropdown"
        placeholder={t(
          'web.admin.channel.units.create.form.floors.placeholder'
        )}
        noOptionsMessage={t(
          'web.admin.channel.units.create.form.floors.noFloorsFound'
        )}
        isSearchable
        items={options}
        onChange={value => handleOnChange(value, 'floors')}
        value={editUnit.floors}
        doTranslation={false}
      />
    </div>
  </div>
);
